export const LEAD_GEN_AD_LANGUAGES = ["en", "es"] as const;

export type LeadGenAdLanguage = (typeof LEAD_GEN_AD_LANGUAGES)[number];

export const DEFAULT_LEAD_GEN_AD_LANGUAGE: LeadGenAdLanguage = "en";

export const LEAD_GEN_AD_LANGUAGE_LABELS: Record<LeadGenAdLanguage, string> = {
  en: "English",
  es: "Spanish",
};

export const LEAD_GEN_CREATIVES_PER_LANGUAGE = 3;

export function isLeadGenAdLanguage(value: unknown): value is LeadGenAdLanguage {
  return value === "en" || value === "es";
}

export function parseLeadGenAdLanguage(value: unknown): LeadGenAdLanguage {
  return isLeadGenAdLanguage(value) ? value : DEFAULT_LEAD_GEN_AD_LANGUAGE;
}

export function parseLeadGenAdLanguages(value: unknown): LeadGenAdLanguage[] {
  const selected = new Set<LeadGenAdLanguage>();
  if (Array.isArray(value)) {
    for (const entry of value) {
      if (isLeadGenAdLanguage(entry)) selected.add(entry);
    }
  }
  const ordered = LEAD_GEN_AD_LANGUAGES.filter((language) => selected.has(language));
  return ordered.length > 0 ? ordered : [DEFAULT_LEAD_GEN_AD_LANGUAGE];
}

export function leadGenRequiredCreativeCount(
  languages: readonly LeadGenAdLanguage[],
): number {
  return LEAD_GEN_CREATIVES_PER_LANGUAGE * Math.max(languages.length, 1);
}
